import { Component, Input } from "@angular/core"
import { NgbModal } from "@ng-bootstrap/ng-bootstrap"
import { UserService } from "../../../services/user.service"
import { AuthModalComponent } from "../../modals/auth-modal/auth-modal.component"
import { StudentLoginModalComponent } from "../../modals/student-login-modal/student-login-modal.component"

@Component({
    selector: "app-register",
    templateUrl: "./register.component.html",
    styleUrls: ["./register.component.less"],
})
export class RegisterComponent {
    @Input() public showSocialIcons: boolean = true
    @Input() public text: string = null
    @Input() public student: boolean = false
    @Input() public nextURL: string = null
    @Input() public overrideStudentNext: boolean = false
    @Input() public mobile: boolean = false

    constructor(
        private modalService: NgbModal,
        public userService: UserService
    ) {}

    public openAuthModal() {
        const modalRef = this.modalService.open(AuthModalComponent)
        modalRef.componentInstance.nextURL = this.nextURL
        modalRef.componentInstance.overrideStudentNext = this.overrideStudentNext
    }

    public openStudentAuthModal() {
        const modalRef = this.modalService.open(StudentLoginModalComponent)
        modalRef.componentInstance.nextURL = this.nextURL
        modalRef.componentInstance.overrideStudentNext = this.overrideStudentNext
    }

    public setWidth() {
        if (this.text) {
            return { width: "auto" }
        }
    }
}
